;(function () {
  'use strict'

  angular.module('contrast.donut').constant('CS_DONUT_CONSTANTS', {
    CHART_SELECTOR: '.cs-donut-chart',
    OUTER_RING: 'cs-donut-outer-ring',
    GROUP: 'cs-donut-group',
    ARC: 'cs-donut-arc',
    PATH: 'cs-donut-path',
    DEFAULT_SIZE: 300,
    DEFAULT_ARC_WIDTH: 20,
    DEFAULT_SELECTED_ARC_RATIO: 1.2,
    DEFAULT_SECONDARY_ARC_WIDTH: 12,
    TOOLTIP_CLASS: 'cs-donut-tooltip'
  })
})()
